import styled, { css } from 'styled-components';

import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

/**
 * This allows the box-shadow of the linkEffect to show up properly.
 * It's missing 1px otherwise because of the overflow: hidden of the Dotdotdot container.
 * The padding and margin properties can be override.
 * By default, we use padding = 6px to see the underline on Safari and margin = -6px to balance the location.
 */

const getLineHeight = (lineHeight: string | number) => css`
  line-height: ${lineHeight};
`;

const ClampedLinkWorkaround = styled(Dotdotdot)<{
  lineHeight: string | number;
  margin: number;
  padding: number;
}>`
  margin: ${(props) => props.margin ?? -6}px;
  padding: ${(props) => props.padding ?? 6}px;
  word-break: break-word;

  ${(props) => props.lineHeight && getLineHeight(props.lineHeight)}
`;

export default ClampedLinkWorkaround;
